import styled from 'styled-components';
import breakpoints from '../utils/miniBreakpoints';
import MiniSBGameModes from '../types/MiniSBGameModes';
import COLORMAP from 'bdata-sns-shared/style/universal.color';

const { mobile } = breakpoints;

export const GameCardsProps = {
    infinity: {
        width: '160px',
        height: '84px'
    },
    gameday: {
        width: '160px',
        height: '74px'
    },
    vertical: {
        width: '100%',
        height: '64px'
    }
};

const GameWrapper = styled.div.attrs({
    'data-mlb-test': 'singleGameContainer'
})`
    background: transparent;
    width: 100%;
    margin-bottom: 4px;
    flex-shrink: 0;
    transition-duration: .2s;
    min-height: 65px;
    font-family: ${({ theme }) => theme.fonts.family.primary};
    ${({ mode }) => mode === MiniSBGameModes.EXPANDED
        ? `
            &:hover {
                transform: scale(1.025);
                box-shadow: 0 0 5px 3px rgba(0, 0, 0, 0.1);
                border-radius: 5px;
            }
        `
        : ''
    }

    ${({ mode }) => mode !== MiniSBGameModes.INFINITY
        ? `
            @media (max-width: ${mobile}) {
                width: ${GameCardsProps[MiniSBGameModes.GAMEDAY].width};
                height: 76px;
                margin-bottom: 0;
                white-space:nowrap;
                box-sizing: border-box;
                position: relative;
                border-color: ${COLORMAP.borderColor};
                border-style: solid;
                border-width: 1px 1px 1px 0;
        
                &:hover {
                    transform: none;
                    box-shadow: none;
                    border-radius: 0;
                }
                height: 74px;
            }
        `
        : ''
    }

    ${({ mode }) => mode === MiniSBGameModes.GAMEDAY
        ? `
            cursor: pointer;
            width: ${GameCardsProps[MiniSBGameModes.GAMEDAY].width};
            height: 74px;
            margin-bottom: 0;
            white-space:nowrap;
            box-sizing: border-box;
            position: relative;
            border-color: ${COLORMAP.borderColor};
            border-style: solid;
            border-width: 1px 1px 1px 0;

            &:hover {
                transform: none;
                box-shadow: none;
                border-radius: 0;
            }
        `
        : ''
    }
`;

export default GameWrapper;
